import { useEffect, useState } from "react";

function Counter({ count  }) {

    const [counter , setCounter] = useState(0);


    useEffect(() => {

        if(counter < count)
        {
        let counter_int = setInterval(() => {
         
                setCounter(prev => prev+1)
            
        } , 35)

        
        return () => {
            clearInterval(counter_int)
          }
        }
        


    })

    return ( 
        <>
            { counter }
        </>
     );
}

export default Counter;